const reveal = (scope = document) => {
  const items = scope.querySelectorAll('[data-nv-reveal]:not([data-nv-ready])');

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach((item) => {
      item.dataset.nvReady = 'true';
      item.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  items.forEach((item) => {
    item.dataset.nvReady = 'true';
    observer.observe(item);
  });
};

document.documentElement.classList.add('nv-enhanced');

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => reveal());
} else {
  reveal();
}

document.addEventListener('shopify:section:load', (event) => reveal(event.target));
